import { autoCapitalize } from '@/utils/autoCapitalize'
import { formatCPF } from '@/utils/formatCPF/formatCPF'
import { phoneReplace } from '@/utils/formatPhone'

class PatientDetailsMapper {
  toDomain(persistenceData) {
    return {
      patientId: persistenceData?.id,
      patientName: autoCapitalize(persistenceData?.nome),
      cpf: formatCPF(persistenceData?.cpf),
      phone: phoneReplace(persistenceData?.telefoneCelular),
      clinic: {
        clinicId: persistenceData?.clinica?.id,
        clinicName: autoCapitalize(persistenceData?.clinica?.nome),
      },
    }
  }
}

export default new PatientDetailsMapper()
